module.exports = {
  title: '编辑协议',
  route: {
    path: 'system-manage',
    children: {
      path: 'protocol-detail',
    },
  },
};
